export enum LicenseType {
  PER_DEVICE = 'PER_DEVICE',
  PER_READING = 'PER_READING',
  PER_SENSOR = 'PER_SENSOR',
  PER_POC = 'PER_POC',
  PER_REMOTE_NODE = 'PER_REMOTE_NODE',
  COMPANY_PARTIAL_LICENSE = 'COMPANY_PARTIAL_LICENSE',
}
